import InterruptGameCommand from "../../../../../shared/src/ranj/app/core/InterruptGameCommand";
import GameModel from "../model/GameModel";

export default class InterruptWorkingMemoryGameCommand extends InterruptGameCommand {
    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {StageManager} stageManager
     * @param {GameModel} gameModel 
     * @param {AppModel} appModel
     */
    constructor(dispatcher, stageManager, appModel, gameModel) {
        super(dispatcher, stageManager, appModel);
        this._gameModel = gameModel;
    }

    execute(evt) {
        super.execute(evt);

        this._gameModel.stopTimer();
    }
}

